import { LabsGqlWorkflowTaskSortField } from '@orthly/graphql-schema';

export const DEFAULT_SORT = { asc: true, key: LabsGqlWorkflowTaskSortField.LabDesignPriority };
